import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { endPoints } from '../../../../../environments/environment';
import { DetalleActaEntrega } from '../entities/detalle-acta-entrega';

@Injectable({
  providedIn: 'root'
})
export class DetalleActaEntregaService {
  private apiUrl = `${endPoints.DetalleActaEntregaService}`;

  constructor(private http: HttpClient) { }

  // Obtener detalles por acta de entrega
  getDetallesByActa(idActaEntrega: number): Observable<DetalleActaEntrega[]> {
    return this.http.get<DetalleActaEntrega[]>(`${this.apiUrl}acta/${idActaEntrega}`);
  }

  // Método alternativo usando filtros
  getDetallesByActaFilter(idActaEntrega: number): Observable<any> {
    const filterQuery = `?filterList=[{"criteria":"eq","field":"idActaEntrega","value1":"${idActaEntrega}","value2":null}]`;
    return this.http.get<any>(`${this.apiUrl}${filterQuery}`);
  }

  // Crear detalle de acta
  createDetalle(detalle: DetalleActaEntrega): Observable<DetalleActaEntrega> {
    return this.http.post<DetalleActaEntrega>(this.apiUrl, detalle);
  }

  // Actualizar detalle de acta
  updateDetalle(id: number, detalle: DetalleActaEntrega): Observable<DetalleActaEntrega> {
    return this.http.put<DetalleActaEntrega>(`${this.apiUrl}/${id}`, detalle);
  }

  // Eliminar detalle de acta
  deleteDetalle(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  // Obtener detalle por ID
  getDetalle(id: number): Observable<DetalleActaEntrega> {
    return this.http.get<DetalleActaEntrega>(`${this.apiUrl}/${id}`);
  }

  // Cambiar estado del detalle
  cambiarEstado(id: number, estado: string): Observable<DetalleActaEntrega> {
    return this.http.patch<DetalleActaEntrega>(`${this.apiUrl}/${id}/estado`, { estado });
  }
} 